"use strict";

exports.__esModule = true;
exports.AdvancedDataTableFields = AdvancedDataTableFields;
exports.boostrapDefaultAdvancedDataTableColumns = boostrapDefaultAdvancedDataTableColumns;
var _react = _interopRequireDefault(require("react"));
var _Core = require("../../Core");
var _widget = require("../AdvancedDataTableColumn/widget");
var _AdvancedDataSources = require("./AdvancedDataSources");
var _Fields = require("./Fields");
var _excluded = ["columns"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function boostrapDefaultAdvancedDataTableColumns(configuration, elementEditor, definition, path) {
  if (configuration === void 0) {
    configuration = {};
  }
  // Use the definition to bootstrap a default configuration for the editor
  var _definition$createDef = definition.createDefault(),
    columns = _definition$createDef.columns,
    defaultConfig = _objectWithoutPropertiesLoose(_definition$createDef, _excluded);
  configuration = defaultConfig;

  // bootstrap the child elements
  elementEditor.modifyElementAt(path, function (el) {
    // Create a column for each in the defaults as a child of the element. Note: Destroys existing configured columns
    el.children = columns.map(function (column) {
      return _widget.AdvancedDataTableColumnWidget.createElement(Object.assign({}, column));
    });
  });
  return configuration;
}

/**
 * Fields for AdvancedDataTableElement.
 */
function AdvancedDataTableFields(props) {
  var path = props.path,
    elementEditor = props.elementEditor,
    element = props.element;
  var renderChildren = function renderChildren(data) {
    var timelineDefinitions = data.timelineDefinitions,
      timelineIdentifiers = data.timelineIdentifiers;
    var dataSource = element.props.dataSource;
    var definition = dataSource && timelineDefinitions[dataSource] ? timelineDefinitions[dataSource] : null;
    var configuration = element.props.configuration;
    if (!configuration && definition) {
      configuration = boostrapDefaultAdvancedDataTableColumns(configuration, elementEditor, definition, path);
      elementEditor.setProp(path, "configuration", configuration);
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "AdvancedDataTableFields"
    }, /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedDataSourceField, {
      key: "AdvancedDataTableFields.AdvancedDataSourceField",
      sources: timelineIdentifiers || [],
      value: dataSource,
      setProp: function setProp(val) {
        if (val !== dataSource) {
          elementEditor.modifyElementAt(path, function (el) {
            if (el.props.dataSource !== val) {
              el.props.configuration = null; // this triggers bootstrap above
              el.children = [];
              el.props.dataSource = val;
            }
          });
        }
      }
    }), /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedAddColumnField, {
      "data-testid": "AdvancedDataTableFields.AddColumnField",
      key: "AdvancedDataTableFields.AddColumnField",
      dataSourceDefinition: definition || {
        columns: [],
        parseData: function parseData() {},
        createDefault: function createDefault() {}
      },
      onAddColumn: function onAddColumn(column) {
        elementEditor.appendElementAt(path, _widget.AdvancedDataTableColumnWidget.createElement(Object.assign({}, column)));
      }
    }), /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedDataRangeSelector, {
      key: "AdvancedDataTableFields.DataRangeSelector",
      value: element.props.dataRange,
      setProp: function setProp(val) {
        elementEditor.modifyElementAt(path, function (el) {
          if (el.props.dataRange !== val) {
            el.props.dataRange = val;
          }
        });
      },
      fetchDataOnlyOnSelection: element.props.fetchDataOnlyOnSelection,
      setFetchOnlyOnSelection: function setFetchOnlyOnSelection(val) {
        elementEditor.modifyElementAt(path, function (el) {
          if (el.props.fetchDataOnlyOnSelection !== val) {
            el.props.fetchDataOnlyOnSelection = val;
          }
        });
      }
    }), /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedPaginationField, {
      key: "AdvancedDataTableFields.PaginationField",
      defaultPageSize: configuration ? configuration.defaultPageSize : "auto",
      setDefaultPageSize: function setDefaultPageSize(val) {
        return elementEditor.setProp(path, "configuration", Object.assign({}, element.props.configuration, {
          defaultPageSize: val
        }));
      },
      enablePagination: configuration ? configuration.enablePagination : true,
      setPagination: function setPagination(val) {
        return elementEditor.setProp(path, "configuration", Object.assign({}, element.props.configuration, {
          enablePagination: val
        }));
      }
    }));
  };
  return /*#__PURE__*/_react["default"].createElement(_AdvancedDataSources.AdvancedDataSourceContext.Consumer, null, function (_ref) {
    var loaded = _ref.loaded,
      fetching = _ref.fetching,
      error = _ref.error,
      data = _ref.data;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, fetching && !data ? /*#__PURE__*/_react["default"].createElement(_Core.Spinner, null) : null, !error && loaded && data ? renderChildren(data) : null);
  });
}